const services = [
  {
    icon: 'ri-smartphone-line',
    title: 'iOS Platform Engineering',
    description:
      'Deep expertise across the full iOS ecosystem, building native solutions that leverage platform capabilities to their fullest potential.',

  },
  {
    icon: 'ri-layout-masonry-line',
    title: 'System Architecture Design',
    description:
      'Comprehensive architectural planning that ensures scalability, maintainability, and seamless integration across system boundaries.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Performance & Scalability',
    description:
      'Rigorous optimization of runtime behaviour, resource utilization, and throughput to handle growing demands without compromise.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Technical Quality Assurance',
    description:
      'Systematic testing strategies, code review practices, and quality gates that uphold reliability across every release cycle.',
  },
];

export default function Services() {
  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.12] tracking-tight">
            Core capabilities
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div key={service.title} className="flex flex-col items-center text-center">
              <div className="w-full aspect-square rounded-2xl bg-background-100 flex items-center justify-center mb-5 relative overflow-hidden">
                <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-secondary-100/80">
                  <i className={`${service.icon} text-2xl md:text-3xl text-secondary-600`}></i>
                </div>
                {index === 0 && (
                  <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-100/90">
                    <span className="font-label text-[10px] font-semibold text-accent-800 tracking-wider uppercase">
                      Core
                    </span>
                  </div>
                )}
              </div>
              <h4 className="font-heading text-lg font-semibold text-foreground-950">
                {service.title}
              </h4>
              <p className="mt-2 font-body text-sm text-foreground-600 leading-relaxed max-w-[240px]">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}